


import bridgeToApp from '@/utils/bridgeToApp';

export default {
    install(Vue) {

        Object.keys(bridgeToApp).map((item) => {
            Vue.prototype['$' + item] = bridgeToApp[item];
        })
    }
};
